import styled from 'styled-components';

/**
 * The notice bar — frame node `18076:22148`, promoted here from the maturity page (CRPD-7267).
 *
 * A bordered bar rather than the dismissible `Banner` above: this state is not news the user can
 * acknowledge and move past, it is what the framework is until someone imports a hierarchy for
 * it. Hence no dismiss, and a 1px `stroke` outline instead of a fill — on the white comparison
 * card the outline is the only thing that makes it a bar at all.
 *
 * Both tokens are exact matches for the frame's own variables: `stroke` is `Cydea/Stroke #E9ECFF`
 * and the icon takes `error`, which is `Cydea/Red #E32121`.
 */
export const Bar = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 8px;
  min-height: 40px;
  padding: 8px 16px;
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  border-radius: 6px;

  svg {
    flex-shrink: 0;
  }
`;
